import { getCurrentInstance, onMounted, ref, watch } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

function normalizeComunicado(comunicado = {}) {
    return {
        ...comunicado,
        listo_para_enviar: comunicado.listo_para_enviar == 1 ? 1 : 0,
        enviar_a: comunicado.enviar_a ? Number(comunicado.enviar_a) : 1,
    };
}

function areSameId(left, right) {
    if (left == null || right == null) {
        return false;
    }

    return String(left) === String(right);
}

export function useFormEmail(props, emit) {
    const { proxy } = getCurrentInstance();
    const eventos = ref([]);
    const bases = ref([]);
    const localComunicado = ref(normalizeComunicado(props.comunicado));
    const uploadImageUrl = `${config.API_BASE}/upload/image?api_key=${localStorage.getItem('token')}&permisos=public`;

    watch(
        () => props.comunicado,
        value => {
            localComunicado.value = normalizeComunicado(value);
        },
        { immediate: true, deep: true }
    );

    function updateLoading(estado) {
        emit('update:loading', estado);
    }

    function getSelectedEventoId() {
        return localComunicado.value?.evento_id?.id || localComunicado.value?.evento_id;
    }

    async function getEvents() {
        updateLoading(true);

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.events.index'),
                {
                    filters: {
                        to_select: true
                    }
                }
            );

            eventos.value = res.data.data;

            const eventoId = getSelectedEventoId();
            if (eventoId) {
                const eventoSeleccionado = eventos.value.find(evento => areSameId(evento.id, eventoId));

                if (eventoSeleccionado) {
                    localComunicado.value.evento_id = eventoSeleccionado;
                }
            }
        } catch (error) {
            proxy.$toast.error(error.response?.data?.message);
        } finally {
            updateLoading(false);
        }
    }

    async function getBases() {
        updateLoading(true);

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.comunicados.bases.index'),
                {
                    filters: {
                        to_select: true
                    }
                }
            );

            bases.value = res.data.data;

            if (localComunicado.value?.base_id) {
                const baseSeleccionada = bases.value.find(base => areSameId(base.id, localComunicado.value.base_id));

                if (baseSeleccionada) {
                    localComunicado.value.base = baseSeleccionada;
                }
            }
        } catch (error) {
            proxy.$toast.error(error.response?.data?.message);
        } finally {
            updateLoading(false);
        }
    }

    function getComunicado() {
        return {
            ...localComunicado.value
        };
    }

    onMounted(() => {
        getEvents();
        getBases();
    });

    return {
        eventos,
        bases,
        localComunicado,
        uploadImageUrl,
        getComunicado,
    };
}
